import { FormItem } from '@framework/form/item/FormItem.tsx';
import { useTreeReferencesContext } from '../../../../../../tree/references/TreeReferencesContext.tsx';
import { ExpressionReferenceInput } from '../../../../../expressions/references/input/ExpressionReferenceInput.tsx';
import { WidgetType } from '../../../../Widget.ts';

export interface IConfirmationConfigInputProps {
  name: string;
}

/**
 * Campo di input per collegare un Widget ad un altro, di tipo conferma:
 * In questo caso il sistema richiede di selezionare un widget di tipo
 * `Confirm` che sarà utilizzato per confermare il valore del widget
 */
export function ConfirmationConfigInput(props: IConfirmationConfigInputProps) {
  const { references } = useTreeReferencesContext();
  return (
    <FormItem
      name={props.name}
      label="Conferma del valore"
      help={
        <>
          Collega il campo a un widget <b>«Conferma»</b>: il campo resta
          bloccato sul valore proposto finché l&apos;utente non lo conferma (o
          non lo modifica e conferma), con i pulsanti. Se l&apos;elenco è vuoto,
          aggiungere prima un widget «Conferma» alla Sezione.
        </>
      }
    >
      <ExpressionReferenceInput
        width="100%"
        size="large"
        name={props.name}
        placeholder="Seleziona un widget di Conferma"
        references={references}
        config={{ filter: r => r.widgetType === WidgetType.Confirm }}
      />
    </FormItem>
  );
}
